import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;

const LEGAL_LINKS = [
  { label: 'Disclaimer', href: 'https://networkcommander.com/disclaimer/' },
  { label: 'Terms', href: 'https://networkcommander.com/terms/' },
  { label: 'Privacy', href: 'https://networkcommander.com/privacy/' },
];

const Footer = () => {
  const getThemeText = () => {
    switch (process.env.REACT_APP_THEME) {
      case 'NETWORK_COMMANDER':
        return 'Network Commander';
      case 'WORKSPACEGEEK':
        return 'WorkspaceGeek';
      case '640TECH':
        return '640Tech';
      default:
        return 'TechTRW';
    }
  };

  const showLegalLinks =
    process.env.REACT_APP_THEME === 'NETWORK_COMMANDER' ||
    process.env.REACT_APP_THEME === 'DEFAULT' ||
    !process.env.REACT_APP_THEME;

  return (
    <AntFooter style={{ textAlign: 'center' }}>
      <div>
        &copy;{new Date().getFullYear()} {getThemeText()} - All rights reserved
      </div>
      {showLegalLinks && (
        <div style={{ marginTop: 8 }}>
          {LEGAL_LINKS.map((link, index) => (
            <React.Fragment key={link.href}>
              {index > 0 && ' | '}
              <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
              </a>
            </React.Fragment>
          ))}
        </div>
      )}
    </AntFooter>
  );
};

export default Footer;
